import { createContext, useContext } from "react";

import type { CampaignTab } from "./campaign-sections";

/**
 * Lets content nested anywhere in a campaign view ask the shell to switch tabs.
 *
 * The tab is `CampaignShell`'s own `useState`, but the things that want to move between
 * tabs are deep inside a per-type view — a turnover task row wanting to point at the
 * contribution breakdown on the Info tab (#3783). Threading a callback down through the
 * campaign registry and every per-type module would couple all of them to one link.
 *
 * `null` outside a shell, on purpose: the same rows render in surfaces that have no tabs
 * at all (the in-game button), and there the link should simply not appear rather than
 * throw or render a dead control.
 */
export const CampaignTabContext = createContext<
  ((tab: CampaignTab) => void) | null
>(null);

export const useCampaignTab = () => useContext(CampaignTabContext);
